import Vue from 'vue'
import axios from 'axios'
import * as Sentry from '@sentry/vue'

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    Accept: 'application/json'
  }
}

config.baseURL = 'https://translations.aaltra.eu'

Vue.prototype.$axiosPoeditor = axios.create(config)

Vue.prototype.$axiosPoeditor.interceptors.request.use((config) => {
  if (process.env.nodeEnv !== 'production')
    console.log('🚀 Making request to ' + config.baseURL + config.url)
  return config
})

Vue.prototype.$axiosPoeditor.interceptors.response.use(
  (response) => {
    if (process.env.nodeEnv !== 'production')
      console.log('🗣 Response: ', response.data)
    return response
  },
  (error) => {
    Sentry.captureMessage(error)
    return Promise.reject(error)
  }
)

// TO BE USED TO CHECK WHICH LANGUAGES ARE AVAILABLE IN POEDITOR
Vue.prototype.$axiosPoeditor.fetchLanguages = (payload) => {
  if (!payload) return
  return Vue.prototype.$axiosPoeditor
    .get(`/languages?projectId=${payload?.id}`)
    .then((response) => {
      if (response) {
        if (response?.data?.response?.status === 'success') {
          return response?.data?.result?.languages?.map((lang) => lang?.code)
        } else {
          console.error(`POEditor API Error: ${response.data.response.message}`)
          return null
        }
      }
      return null
    })
    .catch((error) => {
      console.error('Error fetching languages from POEditor:', error, payload)
      return null
    })
}

Vue.prototype.$axiosPoeditor.fetchTranslations = (payload) => {
  if (!payload) return

  const localToPoeditorMap = {
    // LEFT = JSON files RIGHT = POEditor
    bg: 'bg',
    'bg-BG': 'bg',
    cs: 'cs',
    'cs-CZ': 'cs',
    'de-AT': 'de-at',
    'de-DE': 'de',
    el: 'el',
    'el-GR': 'el',
    'en-BE': 'en',
    'en-GB': 'en',
    'en-IE': 'en-ie',
    es: 'es',
    'es-ES': 'es',
    fi: 'fi',
    'fi-FI': 'fi',
    'fr-BE': 'fr-be',
    'fr-FR': 'fr',
    'fr-LU': 'fr-lu',
    hr: 'hr',
    'hr-HR': 'hr',
    hu: 'hu',
    'hu-HU': 'hu',
    it: 'it',
    'it-IT': 'it',
    nb: 'no',
    'nb-NO': 'no',
    'lt-LT': 'lt',
    'lv-LV': 'lv',
    'nl-BE': 'nl-bel',
    'nl-NL': 'nl',
    pl: 'pl',
    'pl-PL': 'pl',
    pt: 'pt',
    'pt-PT': 'pt',
    ro: 'ro',
    'ro-RO': 'ro',
    sk: 'sk',
    'sk-SK': 'sk',
    sl: 'sl',
    'sl-SI': 'sl',
    sr: 'sr',
    'sr-RS': 'sr',
    'sv-FI': 'sv-fi',
    'sv-SE': 'sv',
    tr: 'tr',
    'tr-TR': 'tr'
  }

  // Function to find the correct POEditor language
  const getPoEditorLanguage = (localLanguage) => {
    const poeditorLanguage = localToPoeditorMap[localLanguage]
    if (!poeditorLanguage) {
      console.error(
        `No matching POEditor language for local language: ${localLanguage}`
      )
      return null
    }
    return poeditorLanguage
  }

  return Vue.prototype.$axiosPoeditor
    .get(
      `/translations?projectId=${payload?.id}&language=${getPoEditorLanguage(
        payload?.language
      )}`
    )
    .then((response) => {
      if (response) {
        if (response?.data?.response?.status === 'success') {
          const data = response?.data?.result?.terms?.reduce((acc, item) => {
            if (item?.term) {
              acc[item.term] = item?.translation?.content?.length
                ? item?.translation?.content
                : null
              if (!acc[item.term]) {
                delete acc[item.term]
              }
            }

            return acc
          }, {})
          return data
        } else {
          console.error(`POEditor API Error: ${response.data.response.message}`)
          return null
        }
      }
      return null
    })
    .catch((error) => {
      console.error(
        'Error fetching translations from POEditor:',
        error,
        payload
      )
      return null
    })
}

export default function(ctx, inject) {
  const isContext = !!(ctx && inject)
  if (isContext) {
    ctx.$axiosPoeditor = Vue.prototype.$axiosPoeditor
    inject('axiosPoeditor', Vue.prototype.$axiosPoeditor)
  } else {
    return Vue.prototype.$axiosPoeditor
  }
}
